"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userStatus = void 0;
const color_const_1 = __importDefault(require("../choices/color.const"));
exports.userStatus = {
    sizeSmall: '12px',
    sizeLarge: '20px',
    borderColorAvailable: color_const_1.default.white,
    borderColorAway: color_const_1.default.white,
    borderColorBusy: color_const_1.default.white,
    borderColorDoNotDisturb: color_const_1.default.white,
    borderColorOffline: color_const_1.default.white,
    borderColorOnBreak: color_const_1.default.white,
    borderColorOnCall: color_const_1.default.white,
    borderColorWorkingOffline: color_const_1.default.white,
};
exports.default = exports.userStatus;
